import axios from 'axios';
import URLS from '../../util/urls.js';
import funcoes from '../../util/funcoes.js';

const state = {
  parametros: {
    formaAluguel: '',
    indiceReajuste: '',
    regraRepasse: '',
    duracao: 0,
    reajuste: 0,
    comissao1oMes: 0,
    comissao: 0,
    mesesMultaRescisao: 0,
    carenciaRepasse: 0,
    multa: 0,
    diasMulta: 0,
    permanenciaDiaria: 0,
    diasPermanenciaDiaria: 0,
    mora: 0,
    diasMora: 0,
    honorariosAdvocaticios: 0,
    diasHonorariosAdvocaticios: 0,
    despesasCobrancas: 0,
    diasDespesasCobrancas: 0, 
    instrucaoBoletoLinha1: '',
    instrucaoBoletoLinha2: '',
    itensReciboParametro: [],
    letrasMaiusculas: false,
    gerarDemonstrativoAposBaixa: false,
    prorrogarComNovoBoleto: false,
    lancarRepasseCaixa: false,
    multaJurosReciboTotal: false,
    incluirMarcaDagua: false,
    assumirDescontoNoGarantido: false,
    alphaMarcaDagua: 0,
    dataEnviarAvisoIptu: funcoes.hoje()
  },

  alugueisAprovados: []
};
const mutations = {
  atualizarParametros(state, payload) {
    state.parametros = payload;
  },
  adicionarItemRecibo(state, payload) {
    state.parametros.itensReciboParametro.push({ ...payload });
  },
  removerItemRecibo(state, payload) {
    let itensRecibo = state.parametros.itensReciboParametro;

    for(let i = 0; i < itensRecibo.length; i++) {
      let atual = itensRecibo[i];
      if(atual === payload) {
        state.parametros.itensReciboParametro.splice(i, 1);
        break;
      }
    }
  },

  atualizarListaAlugueisAprovados(state, payload) {
    state.alugueisAprovados = payload.lista;
  },

  atualizarValorIsEnviarAvisoIptu(state, payload) {
    for(let indexAluguelAprovado = 0; indexAluguelAprovado < state.alugueisAprovados.length; indexAluguelAprovado++) {
      for(let indexAluguelAvisoAtivado = 0; indexAluguelAvisoAtivado < payload.length; indexAluguelAvisoAtivado++) {
        if(state.alugueisAprovados[indexAluguelAprovado].id === payload[indexAluguelAvisoAtivado].id) {
          state.alugueisAprovados[indexAluguelAprovado].isEnviarAvisoIptu = !state.alugueisAprovados[indexAluguelAprovado].isEnviarAvisoIptu;
        }
      }
    }
  }
};

const actions = {
  atualizarValorIsEnviarAvisoIptu(context, payload) {
    context.commit('atualizarValorIsEnviarAvisoIptu', payload)
  },

  recuperarParametros(context, payload) {
    return axios.post(URLS.IMOBILIARIAS_RECUPERAR_PARAMETROS, payload)
      .then((response) => {
        switch(response.data.status) {
          case "SUCESSO":
            context.commit('atualizarParametros', response.data.item);
            return response.data;
          case "SESSAO_EXPIRADA":
            return context.dispatch('loginStore/relogar', {}, { root: true })
              .then((authResponse) => {
                if(authResponse.status === "SUCESSO") {
                  return context.dispatch('recuperarParametros', payload);
                }
              }).catch((error) => {
                throw error;
              });
          default:
            return response.data;
        }
      }).catch((error) => {
        throw error;
      });
  },
  gravarParametros(context, payload) {
    return axios.post(URLS.IMOBILIARIAS_GRAVAR_PARAMETROS, payload)
      .then((response) => {
        switch(response.data.status) {
          case "SUCESSO":
            context.commit('atualizarParametros', response.data.item);
            return response.data;
          case "SESSAO_EXPIRADA":
            return context.dispatch('loginStore/relogar', {}, { root: true })
              .then((authResponse) => {
                if(authResponse.status === "SUCESSO") {
                  return context.dispatch('gravarParametros', payload);
                }
              }).catch((error) => {
                throw error;
              });
          default:
            return response.data;
        }
      }).catch((error) => {
        throw error;
      });
  },

  listarAlugueis(context, payload) {
    return axios.post(URLS.ALUGUEIS_LISTAR, payload)
    .then(response => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarListaAlugueisAprovados', response.data);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('listarAlugueis', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  adicionarItemReciboAutomatico(context, payload) {
    context.commit('adicionarItemRecibo', payload);
  },
  removerItemReciboAutomatico(context, payload) {
    context.commit('removerItemRecibo', payload);
  }
};

export default {
  state,
  mutations,
  actions
}